export enum ControlObjectType {
    // Person types
    Employee = 'employee',
    Contractor = 'contractor',
    Visitor = 'visitor',

    // Equipment types
    Excavator = 'excavator',
    HaulTruck = 'haul',
    Drill = 'drill',
    Dozer = 'dozer',
    Grader = 'grader',
    Bus = 'bus',
    WaterTruck = 'water',
    BlastTruck = 'blast',
    SpecialVehicle = 'special',
    LightVehicle = 'light',
    Locomotive = 'locomotive',
    Dumpcar = 'dumpcar',
    VacuumTruck = 'vacuum',

    // Asset types
    Pump = 'pump',
    Generator = 'generator',
    Crane = 'crane',
    ForkLift = 'fork lift',
    AccessPoint = 'access point',
    Welding = 'welding',

    // Universal types
    Other = 'other'
}
